import _get from "lodash/get";
import translateAlignProp from '../../../../styles/translateAlignProp';
var headerStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    var colors = v.colorScheme[p.color];
    return Object.assign({
      display: 'block',
      color: _get(colors, 'foreground', v.color),
      textAlign: translateAlignProp(p.align)
    }, p.description && {
      marginBottom: 0
    });
  }
};
export default headerStyles;